<mat-card class="user-profile-card">
  <mat-card-content class="card-content">
    <!-- Top Row: Profile Picture and Edit -->
    <div class="profile-row">
      <div class="profile-image-container">
        <img class="profile-picture" alt="Profile picture" [src]="_userProfilePic" />
      </div>
      <div class="counts-container">
        <div class="count-item">
          <div class="count-number">{{ _dics_count || 0 }}</div>
          <div class="count-label">dictionaries</div>
        </div>
        <div class="count-item">
          <div class="count-number">{{ _followers_count || 0 }}</div>
          <div class="count-label">followers</div>
        </div>
        <div class="count-item">
          <div class="count-number">{{ _following_count || 0 }}</div>
          <div class="count-label">following</div>
        </div>
      </div>
      <div class="actions-container">
        <button class="edit-button" *ngIf="_isOwnProfile" mat-stroked-button (click)="openProfilePictureDialog()">
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>
        <div class="follow-container" *ngIf="!_isOwnProfile">
          <ddc-button-follow [_isFollowing]="_isFollowed" (followToggle)="onFollowToggle($event)"></ddc-button-follow>
        </div>
      </div>
    </div>

    <!-- Bottom Row: User Info -->
    <div class="info-row">
      <h2 class="user-name">
        <div *ngIf="_username">{{ _username }}</div>
        @if (_isVerified === true) {
          <mat-icon class="ml-1 small-icon ddc-plus-icon" matTooltip="Verified">verified</mat-icon>
        }
        @if (_subscription === 'Plus') {
          <mat-icon class="ml-1 small-icon ddc-plus-icon" matTooltip="Plus">bolt</mat-icon>
        }
        @if (_subscription === 'Pro') {
          <mat-icon class="ml-1 small-icon ddc-plus-icon" matTooltip="Pro">diamond</mat-icon>
        }
      </h2>

      <p class="user-title" *ngIf="_bio">{{ _bio }}</p>
      <div class="location-info" *ngIf="_country || _city">
        <span>{{ _country }}{{ _country && _city ? ', ' : '' }}{{ _city }}</span>
      </div>
      <div class="user-languages" *ngIf="_favLanguage1 || _favLanguage2 || _favLanguage3">
        <ddc-dual-lng [lng]="_favLanguage1" [lng2]="_favLanguage2" [lng3]="_favLanguage3"></ddc-dual-lng>
      </div>
    </div>
  </mat-card-content>
</mat-card>
